import { Environment } from './environment.model';

export const ENVIRONMENT_PROD: Environment = {
  production: true,
  name: 'prod',
  staticFilesHost: 'https://static.twaice.ai/',
  baseUrlApi: 'https://api.twaice.ai/',
  pshEmbedUrl: 'https://psh.twaice.cloud/psh/login',
  // public identifier for the Transifex project
  transifexToken: '1/e60edf51d3cbc5c2a847caef792f9da32ba18ef6',
  // public HubSpot Portal ID
  hubspotPortalId: '25492978',
  // public Mixpanel ID
  mixpanelId: 'e98640b38fc715de1089148141a0513e',
};
